import { render, staticRenderFns } from "./DropdownNavbar.vue?vue&type=template&id=c4689b6c&lang=html&"
import script from "./DropdownNavbar.vue?vue&type=script&lang=js&"
export * from "./DropdownNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DropdownNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports